import React, { useState, useEffect } from 'react'
import { useStyle } from '../../service/useStyle';
import { ComboBox, Panel } from '@ktr/ktr-materialui-react';
import { Grid, makeStyles, Slider, Divider } from '@material-ui/core';
import { useIntl, FormattedHTMLMessage } from 'react-intl';
import { ClampexType } from '../../types/types';
import { ClampexSizes, ProductInputDataRequiredFields } from '../../redux/product/productTypes';
import Alert from '@material-ui/lab/Alert';
import GetPicturePath from '../../service/GetPicturePath';
import isFieldEmpty from '../../service/IsFieldEmpty';
import BarChart from './BarChart';

const useStyleLocal = makeStyles({
  textboxBefore: {
    marginLeft: "auto"
  },
  boltingTorqueDiv: {
    fontSize: "1rem",
  },
  image: {
    height: "auto",
    // width: "17rem"
  },
  imageAssembly: {
    height: "auto",
    // width: "17rem"
  },
  divider: {
    backgroundColor: "gray",

    marginBottom: "10px"
  },
  alert: {
    //backgroundColor: "#24A3E6",
    //color: "#fff"
    fontSize: "0.8em"
  }
})

interface Props {
  shaftDiameter_d: number | null | undefined,
  hubInnerDiameter_D: number | null | undefined,
  screwBoltingTorqueOverwritePercentage: number | undefined,
  screwBoltingTorque_Ts: number | null | undefined,
  screwBoltingTorque_Ts_db: number | null | undefined,
  clampingForce_PA: number | undefined,
  clampingForce_PO: number | undefined,
  cat_SurfacePressureHub_PN: number | undefined,
  cat_SurfacePressureShaft_PW: number | undefined,
  inputChanged(productInputData: any): any,
  currentClampexType: ClampexType,
  clampexSizes: ClampexSizes[],
  errorFields?: ProductInputDataRequiredFields,
  dimensions_Ds: number | undefined,
  dimensions_B1: number | undefined,
  dimensions_B2: number | undefined,
  dimensions_B3: number | undefined,
  dimensions_B: number | undefined,
  dimensions_D1: number | undefined,
  cat_AxialForce_T: number | undefined,
  cat_AxialForce_FAX: number | undefined,
  screwsize: number | undefined,
  screwLength_mm: number | undefined,
  screwNumber: number | undefined,
  weigth_kg: number | undefined,
  type: ClampexType,
  screwPreloadForce_Fv: number | undefined
}

export default function ClampingElement(props: Props) {
  const classes = useStyle();
  const classesLocal = useStyleLocal();
  const { formatMessage: f } = useIntl();
  const [clampexSize] = useState(props.shaftDiameter_d === null ? "" : props.clampexSizes[props.clampexSizes.findIndex(value => value.shaftDiameter_d === props.shaftDiameter_d)]);

  //just internal state to show directly the effect of the slider value


  const [intScrewBoltingTorqueOverwritePercentage, setIntScrewBoltingTorqueOverwritePercentage] = useState();

  useEffect(() => {

    setIntScrewBoltingTorqueOverwritePercentage(props.screwBoltingTorqueOverwritePercentage ? -Number(props.screwBoltingTorqueOverwritePercentage) : 0);
  }, [props.screwBoltingTorqueOverwritePercentage])

  //set initial screwboltingtorque to inputstore if nothing is defined
  /*useEffect(() => {
    if(props.screwBoltingTorque_Ts === null || props.screwBoltingTorque_Ts === undefined) {
      console.log("screwboldingtorque not defined");
      props.inputChanged({
        screwBoltingTorque_Ts: props.screwBoltingTorque_Ts_db,
        screwBoltingTorqueOverwritePercentage: 0
      });
    }
  },[props.screwBoltingTorque_Ts_db])
*/

  /*useEffect(() => {
      console.log("ScrewBolingTorqueDB", screBoltingTorque);
      props.inputChanged({
        screwBoltingTorque_Ts: props.screwBoltingTorque_Ts_db,
        screwBoltingTorqueOverwritePercentage: 0
      });
  
    },[props.hubInnerDiameter_D])*/


  useEffect(() => {
    
    if (props.type === ClampexType.KTR150) {
      props.inputChanged({
        screwPreloadForce: props.clampingForce_PA,
        screwBoltingTorqueOverwritePercentage: 0
      });
    } else {
      props.inputChanged({
        screwBoltingTorque_Ts: props.screwBoltingTorque_Ts_db,
        screwBoltingTorqueOverwritePercentage: 0
      });
    }


  }, [props.screwBoltingTorque_Ts_db, props.clampingForce_PA])


  const shaftInnerDiameterChanged = (value: ClampexSizes) => {
    if (value !== undefined && value !== null) {
      props.inputChanged({ ...value });


      if (props.type === ClampexType.KTR150) {
        props.inputChanged({
          screwPreloadForce: props.clampingForce_PA,
          screwBoltingTorqueOverwritePercentage: 0
        });
      } else {
        props.inputChanged({
          screwBoltingTorque_Ts: props.screwBoltingTorque_Ts_db,
          screwBoltingTorqueOverwritePercentage: 0
        });
      }
    }

  }

  const handleChange = (event: any, newValue: number | number[]) => {
    if (props.currentClampexType !== ClampexType.KTR150) {


      props.inputChanged({
        //this value have to be a negative value because it will decrease the srewboltingtorque
        screwBoltingTorqueOverwritePercentage: -100 + (newValue as number),
        screwBoltingTorque_Ts: (props.screwBoltingTorque_Ts_db || 0) * (100 - intScrewBoltingTorqueOverwritePercentage) / 100
      });
    } else {
      props.inputChanged({
        screwBoltingTorqueOverwritePercentage: -100 + (newValue as number),
        screwPreloadForce: (props.clampingForce_PA || 0) * (100 - intScrewBoltingTorqueOverwritePercentage) / 100
      });
    }
  };

  const changeInternalState = (event: any, newValue: number | number[]) => {
    setIntScrewBoltingTorqueOverwritePercentage(100 - (newValue as number));
  };

  return (
    <div>
      <h1 style={{fontSize: "1.3rem", marginLeft: "15px"}}><b><FormattedHTMLMessage id="app.clampingelement" defaultMessage="Clamping element"></FormattedHTMLMessage> {" " + props.type} </b></h1>
      <Panel title={""} className={classes.basicDataPanel}>
        <Grid container>
          <Grid xs={12} md={6} item>
            <Grid xs={12} item style={{ textAlign: 'left' }}>
              <b>{f({ id: 'app.clampexelement.dropdown' })}</b>



              <ComboBox
                //value={props.shaftDiameter_d === null ? "" : Object.assign({}, props.clampexSizes[props.clampexSizes.findIndex(value => value.shaftDiameter_d === props.shaftDiameter_d)])}
                value={clampexSize}
                getOptionLabel={(value: ClampexSizes) => String(value.shaftDiameter_d ? value.shaftDiameter_d + "x" + value.hubInnerDiameter_D : f({ id: 'app.clampexelement.selectionPlaceholder' }))}
                errorText={f({ id: 'app.error.required', defaultMessage: 'Required' })}
                //error={props.errorFields === undefined || (props.errorFields.shaftDiameter_d === true && props.shaftDiameter_d !== null) ? false : props.errorFields.shaftDiameter_d}
                error={props.errorFields !== undefined && props.errorFields.shaftDiameter_d && isFieldEmpty(props.shaftDiameter_d)}
                options={props.clampexSizes}
                onChange={(event, value) => shaftInnerDiameterChanged(value)}
              />

            </Grid>
            <Grid container>
              <Grid xs={12} item>
                <h4>{props.shaftDiameter_d ? <div>{f({ id: 'app.clampexelement.dimensions', defaultMessage: 'Dimensions' })}<Divider className={classesLocal.divider}></Divider></div> : ""}</h4>
              </Grid>
              <Grid xs={8} item>
                {props.shaftDiameter_d ? <FormattedHTMLMessage id="app.clampexelement.dimensiond" /> : ""}
              </Grid>
              <Grid xs={4} item>
                {props.shaftDiameter_d ? props.shaftDiameter_d + " mm" : ""}
              </Grid>
              <Grid xs={8} item>
                {props.shaftDiameter_d ? <FormattedHTMLMessage id="app.clampexelement.dimensionD" /> : ""}
              </Grid>
              <Grid xs={4} item>
                {props.hubInnerDiameter_D ? props.hubInnerDiameter_D + " mm" : ""}
              </Grid>
              <Grid xs={8} item>
                {props.dimensions_B && props.shaftDiameter_d ? <FormattedHTMLMessage id="app.clampexelement.dimensionB" /> : ""}
              </Grid>
              <Grid xs={4} item>
                {props.dimensions_B && props.shaftDiameter_d ? props.dimensions_B + " mm" : ""}
              </Grid>
              <Grid xs={8} item>
                {props.dimensions_B1 && props.shaftDiameter_d ? <FormattedHTMLMessage id="app.clampexelement.dimensionB1" /> : ""}
              </Grid>
              <Grid xs={4} item>
                {props.dimensions_B1 && props.shaftDiameter_d ? props.dimensions_B1 + " mm" : ""}
              </Grid>
              <Grid xs={8} item>
                {props.dimensions_B2 && props.shaftDiameter_d && props.type !== ClampexType.KTR105 ? <FormattedHTMLMessage id="app.clampexelement.dimensionB2" /> : ""}
              </Grid>
              <Grid xs={4} item>
                {props.dimensions_B2 && props.shaftDiameter_d && props.type !== ClampexType.KTR105 ? props.dimensions_B2 + " mm" : ""}
              </Grid>
              <Grid xs={8} item>
                {props.dimensions_B3 && props.shaftDiameter_d && props.type !== ClampexType.KTR131 ? <FormattedHTMLMessage id="app.clampexelement.dimensionB3" /> : ""}
              </Grid>
              <Grid xs={4} item>
                {props.dimensions_B3 && props.shaftDiameter_d && props.type !== ClampexType.KTR131 ? props.dimensions_B3 + " mm" : ""}
              </Grid>
              <Grid xs={8} item>
                {props.dimensions_D1 && props.shaftDiameter_d ? <FormattedHTMLMessage id="app.clampexelement.dimensionD1" /> : ""}
              </Grid>
              <Grid xs={4} item>
                {props.dimensions_D1 && props.shaftDiameter_d ? props.dimensions_D1 + " mm" : ""}
              </Grid>

              <Grid xs={8} item>
                {props.screwsize && props.shaftDiameter_d ? <FormattedHTMLMessage id="app.clampexelement.dimensionScrewSize" /> : ""}
              </Grid>
              <Grid xs={4} item>
                {props.screwsize && props.shaftDiameter_d ? props.screwsize + " mm" : ""}
              </Grid>
              <Grid xs={8} item>
                {props.screwLength_mm && props.shaftDiameter_d ? <FormattedHTMLMessage id="app.clampexelement.dimensionScrewLength" /> : ""}
              </Grid>
              <Grid xs={4} item>
                {props.screwLength_mm && props.shaftDiameter_d ? props.screwLength_mm + " mm" : ""}
              </Grid>
              <Grid xs={8} item>
                {props.screwNumber && props.shaftDiameter_d ? <FormattedHTMLMessage id="app.clampexelement.dimensionScrewNumber" /> : ""}
              </Grid>
              <Grid xs={4} item>
                {props.screwNumber && props.shaftDiameter_d ? props.screwNumber : ""}
              </Grid>
              <Grid xs={8} item>
                {props.weigth_kg && props.shaftDiameter_d ? <FormattedHTMLMessage id="app.clampexelement.weigth" /> : ""}
              </Grid>
              <Grid xs={4} item>
                {props.weigth_kg && props.shaftDiameter_d ? props.weigth_kg + " kg" : ""}
              </Grid>
            </Grid>


            <Grid container style={{ textAlign: 'left' }}>
              <Grid xs={12} item>
                <h4>{props.shaftDiameter_d ? <div>{f({ id: 'app.clampexelement.data', defaultMessage: 'Data' })}<Divider className={classesLocal.divider}></Divider> </div> : ""}</h4>
              </Grid>
              <Grid xs={8} item>
                {props.shaftDiameter_d ? f({ id: 'app.clampexelement.transferableTorque' }) : null}
              </Grid>
              <Grid xs={4} item>
                {props.shaftDiameter_d ? <span>{props.cat_AxialForce_T + " Nm (F"}<sub>ax</sub>{" = 0 kN)"}</span> : null}
              </Grid>
              <Grid xs={8} item>
                {props.shaftDiameter_d ? <FormattedHTMLMessage id="app.clampexelement.transferableAxialForce" /> : null}
              </Grid>
              <Grid xs={4} item>
                {props.shaftDiameter_d ? Math.round(Number(props.cat_AxialForce_FAX)) + " kN (T = 0 Nm) " : null}
              </Grid>
              <Grid xs={8} item>
                {props.shaftDiameter_d ?
                  <span>
                    <FormattedHTMLMessage id="app.clampexelement.surfacepressureshaft" />
                    &nbsp;
                </span>
                  : null}
              </Grid>
              <Grid xs={4} item>
                {props.shaftDiameter_d ? Math.round(props.cat_SurfacePressureShaft_PW || 0) + " N/mm²" : ""}
              </Grid>
              <Grid xs={8} item>
                {props.shaftDiameter_d ?
                  <span>
                    <FormattedHTMLMessage id="app.clampexelement.surfacepressurehub" />
                    &nbsp;
                </span>
                  : null}
              </Grid>
              <Grid xs={4} item>
                {props.shaftDiameter_d ? Math.round(props.cat_SurfacePressureHub_PN || 0) + " N/mm²" : ""}
              </Grid>

              <Grid xs={12} item>
                <h4>{props.shaftDiameter_d ? <div>{f({ id: 'app.clampexelement.clampingelement', defaultMessage: 'Data' })}<Divider className={classesLocal.divider}></Divider> </div> : ""}</h4>
              </Grid>

              <Grid xs={12} item>
                {(props.screwBoltingTorque_Ts && props.shaftDiameter_d) || (props.clampingForce_PA && props.shaftDiameter_d) ?
                  props.currentClampexType === ClampexType.KTR150 ?
                    <FormattedHTMLMessage id="app.labelSpannelement.screwpreloadforce" /> :
                    <FormattedHTMLMessage id="app.labelSpannelement.screwboltingtorque" />
                  : ''}
                {props.shaftDiameter_d ?
                  <span>
                    &nbsp;
                        {
                      props.currentClampexType === ClampexType.KTR150 ?
                        Math.round(((props.clampingForce_PA || 0) * (100 - intScrewBoltingTorqueOverwritePercentage) / 100) * 100) / 100
                        : (props.screwBoltingTorque_Ts_db || 0) * (100 - intScrewBoltingTorqueOverwritePercentage) / 100
                    }&nbsp;{"Nm"}

                    &nbsp;({100 - intScrewBoltingTorqueOverwritePercentage} %)
                    </span>
                  : ""}
              </Grid>
              
              <Grid xs={12} item>
                {props.shaftDiameter_d ?
                  <Slider
                    value={100 - intScrewBoltingTorqueOverwritePercentage}
                    defaultValue={100}
                    onChangeCommitted={handleChange}
                    onChange={changeInternalState}
                    valueLabelDisplay="auto"
                    aria-label="pretto slider"
                    step={5}
                    max={100}
                    min={60}
                  />
                  : ""}
              </Grid>
              <Grid xs={12} item>
                {props.shaftDiameter_d ?
                  <BarChart percentage={100 - intScrewBoltingTorqueOverwritePercentage}/>
                  : ""}
              </Grid>

              <Grid xs={12} item>
                {props.currentClampexType !== ClampexType.KTR150 && props.shaftDiameter_d ?
                  <Alert className={classesLocal.alert} severity="info"><FormattedHTMLMessage id="app.clampingelement.info" /></Alert>

                  : ""}
              </Grid>



            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            {props.shaftDiameter_d ?
              <Grid container>
                <Grid item style={{ textAlign: "center" }} xs={12}>
                  <img className={classesLocal.image} alt="img" src={GetPicturePath(props.type).dimensioning} />

                </Grid>
                {props.type !== ClampexType.KTR131 ?
                  <Grid item style={{ textAlign: "center" }} xs={12}>
                    <img className={classesLocal.imageAssembly} alt="img" src={GetPicturePath(props.type).dimensioningAssembled} />
                  </Grid>
                  : ""}
              </Grid>
              : ""}
          </Grid>
        </Grid>
      </Panel>
    </div>
  )
}